import React, { useState, Fragment, useEffect } from "react";
import { locales } from "../i18n/i18n";
import { cn } from "../util";

function isEnPath(pathname) {
  console.log(pathname);
  return pathname === "/en" || pathname.startsWith("/en/");
}
function stripEn(pathname) {
  return isEnPath(pathname) ? pathname.replace(/^\/en(\/)?/, "/") : pathname;
}
function addEn(pathname) {
  return isEnPath(pathname)
    ? pathname
    : pathname === "/"
      ? "/en/"
      : "/en" + pathname;
}

export const LanguageSwitcher = () => {
  const [locale, setLocale] = useState("de");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setLocale(isEnPath(window.location.pathname) ? "en" : "de");
    }
  }, []);

  const onChange = (e) => {
    const next = e.target.value;
    setLocale(next);
    try {
      localStorage.setItem("lang", next);
    } catch (e) {}
    const { pathname, search } = window.location;
    const targetPath = next === "en" ? addEn(pathname) : stripEn(pathname);
    window.location.assign(targetPath + (search || ""));
  };

  return (
    <div className={cn("flex items-center gap-2")}>
      {locales.map((l, index) => (
        <Fragment key={l}>
          <button
            value={l}
            onClick={() => onChange({ target: { value: l } })}
            className={cn(
              `font-formula font-medium ${l === locale ? "opacity-100" : "opacity-40"} transition-opacity hover:opacity-80`,
            )}
          >
            {l.toUpperCase()}
          </button>
          {index < locales.length - 1 && (
            <span className={cn("font-formula font-medium")}>/</span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
